import * as React from 'react';
import * as moment from 'moment';
import { observer } from 'mobx-react';
import { computed } from 'mobx';
import { TrackersData } from 'data/TrackersData';

import './DayLabels.pcss';

const DAY_LABEL_FORMAT = 'ddd M/D';

@observer
class DayLabels extends React.Component {
 
  @computed 
  get labels() {
    const dayOfWeek = moment(TrackersData.weeklyMoment);
    const labels:Array<string> = [];
    for(let i=0;i<7;i++) {
      labels.push(dayOfWeek.format(DAY_LABEL_FORMAT));
      dayOfWeek.add(1, 'd');
    }
    return labels;
  }

  @computed 
  get todayLabel() {
    return moment().format(DAY_LABEL_FORMAT);
  }
  render() {
    return (
      <div className="dayLabels">
        {this.labels.map(day=>
          <div key={day} className="day">
            <h3 className={day===this.todayLabel?'today':''}>{day}</h3>
            {/* <div className="vline"></div> */}
          </div>
        )}
      </div>
    );    
  }
}

export { DayLabels };

